import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { Provider } from "@redotech/redo-order-common/provider";
import { createContext, memo, ReactNode } from "react";

export const EnabledFulfillmentProvidersContext = createContext<
  readonly Provider[] | undefined
>(undefined);

export const EnabledFulfillmentProvidersProvider = memo(
  function EnabledFulfillmentProvidersProvider({
    children,
    loadingContent,
    renderWhileLoading = false,
  }: {
    children: ReactNode;
    loadingContent?: ReactNode;
    renderWhileLoading?: boolean;
  }) {
    const client = useRequiredContext(RedoMerchantRpcClientContext);

    const enabledOmsProvidersLoad = useLoad(
      (signal) => client.getEnabledProviders({}, { signal }),
      [client],
    );

    if (!enabledOmsProvidersLoad.value && !renderWhileLoading) {
      return loadingContent;
    }

    return (
      <EnabledFulfillmentProvidersContext.Provider
        value={enabledOmsProvidersLoad.value ?? []}
      >
        {children}
      </EnabledFulfillmentProvidersContext.Provider>
    );
  },
);
